(function () {
  let modal;
  let dialog;
  let backdrop;
  let closeBtn;
  let bodyEl;
  let mediaEl;

  function ensureModal() {
    modal = document.querySelector('.noendy-quick-view');
    if (!modal) return false;
    dialog = modal.querySelector('.noendy-quick-view__dialog');
    backdrop = modal.querySelector('.noendy-quick-view__backdrop');
    closeBtn = modal.querySelector('.noendy-quick-view__close');
    bodyEl = modal.querySelector('[data-quick-view-body]');
    mediaEl = modal.querySelector('[data-quick-view-media]');
    if (!modal._noendyBound) {
      modal._noendyBound = true;
      backdrop?.addEventListener('click', close);
      closeBtn?.addEventListener('click', close);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
    }
    return true;
  }

  async function open(handle) {
    if (!ensureModal() || !handle) return;
    setLoading();
    show();

    try {
      const response = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('fetch failed');
      const product = await response.json();
      render(product);
    } catch (_e) {
      bodyEl.innerHTML = `<p class="noendy-quick-view__loading">Ürün yüklenemedi. <a href="/products/${handle}">Ürün sayfasına git</a></p>`;
    }
  }

  function show() {
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function setLoading() {
    if (mediaEl) mediaEl.innerHTML = '';
    if (bodyEl) bodyEl.innerHTML = '<p class="noendy-quick-view__loading">Yükleniyor…</p>';
  }

  function formatMoney(cents) {
    const value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${value} TL`;
  }

  function render(product) {
    const variant = product.variants && product.variants[0];
    const priceHtml = variant ? formatMoney(variant.price) : '';
    const imageHtml = product.featured_image
      ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy">`
      : '';

    if (mediaEl) mediaEl.innerHTML = imageHtml;
    if (bodyEl) {
      bodyEl.innerHTML = `
        ${product.vendor ? `<p class="noendy-quick-view__vendor"></p>` : ''}
        <h2 class="noendy-quick-view__title"></h2>
        <p class="noendy-quick-view__price">${priceHtml}</p>
        <div class="noendy-quick-view__description"></div>
        <div class="noendy-quick-view__cta">
          <button type="button" class="button button--primary" data-quick-add="${variant ? variant.id : ''}" ${variant && variant.available ? '' : 'disabled'}>
            ${variant && variant.available ? 'Sepete ekle' : 'Tükendi'}
          </button>
          <a class="noendy-quick-view__view" href="${product.url}">Tüm detaylar →</a>
        </div>
      `;
      if (product.vendor) bodyEl.querySelector('.noendy-quick-view__vendor').textContent = product.vendor;
      bodyEl.querySelector('.noendy-quick-view__title').textContent = product.title;
      const desc = bodyEl.querySelector('.noendy-quick-view__description');
      if (desc) {
        const text = (product.description || '').replace(/<\/?[^>]+>/g, '').slice(0, 240);
        desc.textContent = text + (text.length === 240 ? '…' : '');
      }

      const addBtn = bodyEl.querySelector('[data-quick-add]');
      if (addBtn) addBtn.addEventListener('click', () => addToCart(addBtn.dataset.quickAdd));
    }
  }

  async function addToCart(variantId) {
    if (!variantId) return;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('add failed');
      const item = await response.json();
      if (window.NoendyToast) {
        window.NoendyToast.show({ title: 'Sepete eklendi', message: item.product_title, type: 'success' });
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { silent: true } }));
      close();
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIcon) {
        try {
          const sectionResp = await fetch(`/?sections=cart-icon-bubble`);
          const sections = await sectionResp.json();
          if (sections['cart-icon-bubble']) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = sections['cart-icon-bubble'];
            const newBubble = wrapper.querySelector('#cart-icon-bubble');
            if (newBubble) cartIcon.innerHTML = newBubble.innerHTML;
          }
        } catch (_e) {}
      }
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        try { cartDrawer.open(); } catch (_e) {}
      }
    } catch (_e) {
      if (window.NoendyToast) {
        window.NoendyToast.show({ title: 'Eklenemedi', message: 'Lütfen tekrar dene.', type: 'error' });
      }
    }
  }

  function injectTriggers() {
    const cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper, .card');
    cards.forEach((card) => {
      if (card.querySelector('.noendy-quick-view-trigger')) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      const handle = match[1];

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'noendy-quick-view-trigger';
      btn.dataset.quickViewHandle = handle;
      btn.innerHTML = '<span>Hızlı bak</span>';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        open(handle);
      });

      card.style.position = card.style.position || 'relative';
      const media = card.querySelector('.card__media, .card-wrapper__media, .media');
      if (media) {
        media.style.position = media.style.position || 'relative';
        media.appendChild(btn);
      } else {
        card.appendChild(btn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTriggers);
  } else {
    injectTriggers();
  }
  document.addEventListener('shopify:section:load', injectTriggers);

  window.NoendyQuickView = { open, close };
})();
